import { HANDLEBAR_TOKEN_DATA_ATTR } from '../constants';

export const replaceTokenWithHandlebars = (token: Element) => {
  const handlebar = token.getAttribute(HANDLEBAR_TOKEN_DATA_ATTR) ?? '';
  const handlebarFragment = token.ownerDocument.createTextNode(handlebar);
  token.replaceWith(handlebarFragment);
};
